export const common = {
  nav: {
    home: 'Home',
    about: 'About Us',
    services: 'Services',
    muviSpace: 'MuVi Space',
    equipment: 'Equipment',
    locations: 'Locations',
    contact: 'Contact',
    login: 'Login',
    account: 'Account',
    profile: 'Profile',
    orders: 'Orders',
    notifications: 'Notifications',
    logout: 'Logout',
    logoutError: 'Logout failed, please try again',
    user: 'User',
    language: 'Language'
  },
  footer: {
    about: 'About LensBank',
    aboutDesc: 'Over a decade of professional equipment rental experience, a trusted brand working with filmmakers worldwide',
    quickLinks: 'Quick Links',
    services: 'Services',
    contact: 'Contact',
    phone: 'Phone',
    email: 'Email',
    address: 'Address',
    followUs: 'Follow Us',
    poweredBy: 'PowerAslan'
  },
  common: {
    learnMore: 'Learn More',
    viewDetails: 'View Details',
    bookNow: 'Book Now',
    submit: 'Submit',
    cancel: 'Cancel',
    confirm: 'Confirm',
    save: 'Save',
    edit: 'Edit',
    delete: 'Delete',
    search: 'Search',
    filter: 'Filter',
    reset: 'Reset',
    loading: 'Loading...',
    noData: 'No data available'
  },
  contact: {
    pageTitle: 'Contact Us',
    pageDesc: 'Whether for equipment rental, long-term partnership, or project consultation, fill out the form below and we\'ll get back to you shortly',
    formTitle: 'Partnership Inquiry Form',
    successMessage: 'Your form has been submitted successfully! We\'ll be in touch soon.',
    errorMessage: 'Submission failed. Please try again later or call us directly.',
    companyName: 'Company / Organization',
    companyNamePlaceholder: 'Enter your company or organization name',
    contactName: 'Contact Name',
    contactNamePlaceholder: 'Enter your name',
    phone: 'Phone',
    phonePlaceholder: 'e.g. +886-912-345-678',
    email: 'Email',
    emailPlaceholder: 'example@company.com',
    cooperationType: 'Cooperation Type (multiple allowed)',
    cooperationTypes: {
      shortTerm: 'Short-term Rental',
      longTerm: 'Long-term Rental',
      production: 'Film Production',
      crew: 'Crew Support',
      enterprise: 'Enterprise Plan',
      education: 'Educational Institution',
      other: 'Other'
    },
    budget: 'Budget Range',
    budgetPlaceholder: 'Select budget range',
    budgetOptions: {
      under10: 'Under NT$100,000',
      range1030: 'NT$100,000 – 300,000',
      range3050: 'NT$300,000 – 500,000',
      range50100: 'NT$500,000 – 1,000,000',
      over100: 'Over NT$1,000,000',
      discuss: 'To be discussed'
    },
    startDate: 'Expected Start Date',
    rentalDuration: 'Rental Duration',
    rentalDurationPlaceholder: 'Select duration',
    rentalDurationOptions: {
      days13: '1–3 days',
      days47: '4–7 days',
      weeks12: '1–2 weeks',
      weeks24: '2–4 weeks',
      month1plus: '1 month or more',
      longTerm: 'Long-term partnership'
    },
    requirements: 'Requirements',
    requirementsPlaceholder: 'Describe your needs, e.g. equipment types, shooting purpose, special requirements...',
    maxChars: 'Max 500 characters',
    source: 'How did you hear about us?',
    sourcePlaceholder: 'Select an option',
    sourceOptions: {
      search: 'Web Search',
      social: 'Social Media',
      friend: 'Friend Referral',
      reputation: 'Industry Word of Mouth',
      event: 'Exhibition / Event',
      other: 'Other'
    },
    submitButton: 'Submit Form',
    submitting: 'Submitting...',
    contactInfo: 'Contact Information',
    phoneLabel: 'Phone',
    emailLabel: 'Email',
    lineLabel: 'LINE Official Account',
    businessHours: 'Business Hours',
    weekdays: 'Monday to Sunday',
    hours: '09:00 – 18:00',
    urgentService: 'Urgent Requests',
    urgentServiceDesc: 'For urgent inquiries, please call or contact us via LINE directly. We\'ll prioritize your request.',
    required: '*'
  },
  adminNav: {
    dashboard: 'Dashboard',
    orders: 'Orders',
    customers: 'Customers',
    equipment: 'Equipment',
    equipmentList: 'Equipment List',
    equipmentItems: 'Item Management',
    categories: 'Categories',
    brands: 'Brands',
    accessories: 'Accessories',
    locations: 'Locations',
    vehicles: 'Vehicles',
    urent: 'Urent',
    urentApplications: 'Applications',
    urentLedger: 'Ledger',
    urentContracts: 'Contracts',
    prepaid: 'Prepaid',
    prepaidApplications: 'Applications',
    prepaidCustomers: 'Customers',
    prepaidLedger: 'Ledger',
    prepaidPlans: 'Plans',
    analytics: 'Analytics',
    attendance: 'Attendance',
    schedules: 'Scheduling',
    aiAgent: 'AI / Runtime',
    serviceCases: 'Case Videos',
    contracts: 'Contracts',
    legalSettings: 'Company Settings',
    forms: 'Forms',
    cms: 'CMS',
    frontendImages: 'Frontend Images',
    muviSpace: 'MuVi Space',
    muviBookings: 'Bookings',
    muviContent: 'Content',
    muviSettings: 'Settings',
    admins: 'Admins',
    milestones: 'Milestones',
    settings: 'Settings',
    googleCalendar: 'Google Calendar',
    lineNotify: 'LINE Notify',
    apiSettings: 'API Settings',
    storefrontSort: 'Storefront Product Sort',
    systemGovernance: 'System Governance',
  },
  adminNavGroups: {
    frontendVisual: 'Frontend Visuals',
    dailyOps: 'Daily Operations',
    productManagement: 'Product Management',
    customerManagement: 'Customer Management',
    legalContracts: 'Legal / Contracts',
    accountingReports: 'Accounting / Reports',
    systemManagement: 'System Management',
  },
  orderGovernance: {
    phasePreContract: 'Pre-Contract',
    phaseActiveRental: 'Active Rental',
    phaseTerminal: 'Closed / Terminal',
    contractActive: 'Contract Active',
    riskTransferred: 'Risk Transferred',
    restrictedRollback: 'Status Rollback Restricted',
    legalHold: 'Legal Hold',
    earlyPickupApproval: 'Early Pickup Approval',
    abnormalFlow: 'Abnormal Flow',
    overdue: 'Overdue',
    disputed: 'Under Dispute',
    approvedNotReady: 'Order Accepted',
    approvedNotReadyDesc: 'Order has been accepted, but this does not mean equipment is ready for pickup. Ready-for-pickup requires an explicit future action/event.',
    rentalActiveTitle: 'Contract Active — Risk Transferred',
    rentalActiveDesc: 'Equipment has been handed off; rental contract is active and risk/custody has transferred to the customer.',
    cannotOrdinaryCancel: 'Cannot Ordinary Cancel',
    rollbackNeedsManager: 'Rollback Requires Manager Approval',
    rollbackAlternative: 'For cancellation, use return / dispute / agreement termination flow.',
    canonicalState: 'Canonical State',
    legacyStatus: 'Legacy Status',
    pickupGovernance: 'Pickup Governance',
    notificationEvent: 'Notification Event',
    readyForPickupBlocked: 'ready_for_pickup auto-inference blocked',
    pendingBackend: 'Mock / Pending backend',
    needInfoAdminLabel: 'Needs Info / Under Review',
    needInfoCustomerLabel: 'Additional info required — please follow store instructions.',
    completedWarning: 'Return/completion flow has run, but legal retention closure requires separate confirmation.',
  },
  aiAgent: {
    pageTitle: 'AI / Runtime Management Center',
    pageSubtitle: 'Runtime Governance — Provider Status, Notification Templates, Delivery Logs, AI Conversation Governance',
    tabOverview: 'Overview',
    tabProviders: 'Providers',
    tabNotifications: 'Notifications',
    tabTemplates: 'Templates',
    tabDeliveries: 'Deliveries',
    tabConversations: 'Conversations',
    tabAudit: 'Tool Audit',
    tabPolicies: 'Policies',
    tabDeadLetters: 'Dead Letters',
    mockBanner: 'Mock Data — Backend not connected',
    sourcePendingBanner: 'Pending backend connection',
    realDataLabel: 'Real data connected',
    mockDataLabel: 'Mock data',
    tokenConfigured: 'Token Configured',
    tokenNotConfigured: 'Token Not Configured',
    environment: 'Environment',
    lastWebhook: 'Last Webhook',
    lastDelivery: 'Last Delivery',
    deadLetters: 'Dead Letters',
    maxCallsPerDay: 'Max Calls / Day',
    providerStatusSummary: 'Provider Status Summary',
    runtimeArchitecture: 'Runtime Architecture',
    notificationRuntime: 'Notification Runtime',
    aiConversationRuntime: 'AI Conversation Runtime',
    deliveryLog: 'Delivery Log',
    deadLetterQueue: 'Dead Letter Queue',
    internalOperations: 'Internal Operations',
    customerOrders: 'Customer Order Notifications',
    previewText: 'Preview Text',
    allowedVariables: 'Allowed Variables',
    forbiddenNote: 'Forbidden Note',
    safeResponse: 'Safe Response',
    retryCount: 'Retry Count',
    eventType: 'Event Type',
    terminalReason: 'Terminal Reason',
    retryEligible: 'Retry Eligible',
    safePayload: 'Safe Payload Summary',
    providerCategory: 'Provider',
    deliveryCategory: 'Delivery',
    securityCategory: 'Security',
    privacyCategory: 'Privacy',
    noTokenDisplay: 'Provider token is not displayed or entered on this page',
    tokenOnlyInSecret: 'Token is only stored in Railway / Supabase Secret',
    toolCallAuditLog: 'Tool Call Audit Log',
    conversationLog: 'Conversation Log',
    statusEnabled: 'Enabled',
    statusDisabled: 'Disabled',
    ruleEnabled: 'Enabled',
    ruleDisabled: 'Disabled',
    deliveryModeDisabled: 'Disabled',
    deliveryModeFake: 'Fake Mode',
    deliveryModeDryRun: 'Dry-run Mode',
    eventTypeLabel: 'Event Type',
    providerPurposeLabel: 'Provider Purpose',
    audienceScopeLabel: 'Audience',
    maxCallsLabel: 'Max Calls per Event',
    templateKeyLabel: 'Template Key',
    confirmationTitle: 'Confirm Notification Rule Change',
    confirmationLine1: 'This only changes notification rule config.',
    confirmationLine2: 'This will not send LINE messages.',
    confirmationLine3: 'This will not trigger live order hooks.',
    confirmationLine4: 'This will not create notification events.',
    auditTitle: 'Notification Rule Change History',
    auditAction: 'Action',
    auditChangedFields: 'Changed Fields',
    auditReasonCode: 'Reason Code',
    auditActorRole: 'Actor Role',
    auditTimestamp: 'Timestamp',
    noRulesTitle: 'No notification rules yet',
    noRulesDesc: 'Owner / super_admin can create disabled / fake / dry-run rules.',
    permissionDeniedRules: 'No permission to view notification rules',
    sourcePendingRules: 'Pending backend connection',
    modeMock: 'Mock',
    modeDryRun: 'Dry Run',
    modeRealStaging: 'Staging',
    modeProduction: 'Production',
    restrictedView: 'Operational summary only (technical details hidden)',
    adminOnlyTechnical: 'Technical details restricted to system governance roles',
  },
  analytics: {
    pageTitle: 'Analytics Center',
    pageSubtitle: 'Source: admin-analytics-read — read-only, no purchase/retirement execution',
    loading: 'Loading analytics data...',
    empty: 'No analytics data matching current criteria',
    scoped: 'This role can only view analytics within authorized scope',
    error: 'Unable to load analytics data, please try again later',
    permissionDenied: 'No permission to view this analytics data',
    sourcePending: 'Pending backend connection',
    mockData: 'Mock data',
    suggestionOnly: 'Suggestion only, will not auto-execute',
    humanReviewRequired: 'Human review required',
    notExecutable: 'Execution not yet available',
    revenueSectionTitle: 'Revenue Overview',
    revenueSectionNote: 'Operational revenue only, not final accounting figures',
    storeSectionTitle: 'Store Performance',
    productSectionTitle: 'Product Performance',
    productSectionNote: 'Product-level only, does not represent individual serial-number items',
    itemAssetSectionTitle: 'Equipment Assets',
    itemAssetSectionNote: 'Serial number masked, full serial not displayed',
    procurementSectionTitle: 'Procurement Candidates',
    retirementSectionTitle: 'Retirement / Clearance Candidates',
    aiSummarySectionTitle: 'AI Safe Summary Data',
    aiSummarySectionNote: 'AI analysis not yet enabled',
  },
  storefrontSort: {
    pageTitle: 'Storefront Product Sort Settings',
    pageSubtitle: 'Configure default sort strategy and available sort options for storefront product listings',
    pendingBanner: 'Pending backend connection',
    pendingDesc: 'admin-storefront-sort-settings-read / update APIs not yet deployed. UI is read-only preview only.',
    scopeTitle: 'Scope Notice',
    scopeCopy1: 'This setting only affects storefront product listings (/equipment, category, brand, search pages) and does NOT affect admin product management list sorting/filtering.',
    scopeCopy2: 'Storefront sort application requires a separate storefront integration gate; this page currently only manages sort strategy.',
    strategyCardTitle: 'Sort Strategy Settings',
    defaultSortMode: 'Default Sort Mode',
    defaultSortModeHint: 'Default mode must remain enabled in sort options.',
    enabledSortModes: 'Enabled Sort Options (customer-facing)',
    enabledSortModesHint: 'Unchecking hides the option from storefront sort dropdown. Default mode cannot be disabled.',
    featuredFirst: 'Featured Products First',
    featuredFirstDesc: 'When enabled, products tagged as Featured will appear at the top of listings',
    directionControls: 'Direction Controls',
    fixedDirection: 'Fixed',
    auditTitle: 'Change History',
    auditEmpty: 'Pending backend — No change history yet',
    auditEmptyHint: 'Recent changes will appear after admin-storefront-sort-settings-audit-read API is deployed.',
    saveSettings: 'Save Settings',
    saving: 'Saving...',
    previewOnly: 'All changes are preview-only on this page and will not write to backend or affect storefront sorting.',
    savePending: 'Save pending backend connection',
  }
};
